module.exports = __webpack_public_path__ + "static/media/big_dill.2ea63381.png";